import { createSlice } from "@reduxjs/toolkit";
import { FILTER_ALL, USERNAME } from "constants/systemAdmin";
import { setPasswordExpiry } from "utils";

const initialState = {
  adminType: null, // systemAdmin or cloudAdmin
  workspacesInfo: undefined,
  usersInfo: undefined,
  redirectedWorkspace: undefined,
  licenseInfo: undefined,
  tabActive: 0,
  searchTerm: "",
  userSearchTerm: "",
  sortBy: { column: USERNAME, desc: true },
  filterUsers: FILTER_ALL,
  isUsernamePassword: true,
  passwordExpiry: "Never", // NOSONAR javascript:S2068 - display value for no-expiry policy, not a hardcoded credential
  sso: {
    id: null,
    url: null,
    cert: null,
  },
};

export const systemAdminSlice = createSlice({
  name: "systemAdmin",
  initialState,
  reducers: {
    setAdminType: (state, action) => {
      state.adminType = action.payload;
    },
    setWorkspacesInfo: (state, action) => {
      state.workspacesInfo = action.payload;
    },
    setTabActive: (state, action) => {
      return {
        ...state,
        tabActive: action.payload,
      };
    },
    setWorkspacesSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    },
    setSortBy: (state, action) => {
      state.sortBy = action.payload;
    },
    filterUsers: (state, action) => {
      state.filterUsers = action.payload;
    },
    setRedirectedWorkspace: (state, action) => {
      state.redirectedWorkspace = action.payload;
    },
    setUserSearchTerm: (state, action) => {
      state.userSearchTerm = action.payload;
    },
    setUsersInfo: (state, action) => {
      state.usersInfo = action.payload;
    },
    setLicenseInfo: (state, action) => {
      state.licenseInfo = action.payload;
    },
    setAuthentication: (state, action) => {
      state.sso = {
        id: action.payload.id,
        url: action.payload.url,
        cert: action.payload.cert,
      };

      state.isUsernamePassword =
        action.payload.authentication === "UsernamePassword";

      state.passwordExpiry = setPasswordExpiry(action.payload.passwordExpiry);
    },
    setWorkspaceBannerProperties: (state, action) => {
      state.workspacesInfo.workspaces = state.workspacesInfo.workspaces.map(
        (workspace) =>
          workspace.id === action.payload.id
            ? {
                ...workspace,
                bannerProperties: {
                  message: action.payload.message,
                  enabled: action.payload.enabled,
                  colour: action.payload.colour,
                  background: action.payload.background,
                },
              }
            : workspace
      );
    },
    setPasswordExpiryPeriod: (state, action) => {
      state.workspacesInfo.workspaces = state.workspacesInfo.workspaces.map(
        (workspace) =>
          workspace.id === action.payload.workspaceId
            ? {
                ...workspace,
                passwordExpiryPeriod: action.payload.passwordExpiryPeriod,
              }
            : workspace
      );
    },
    setWorkspaceLicense: (state, action) => {
      state.workspacesInfo.workspaces = state.workspacesInfo.workspaces.map(
        (workspace) =>
          workspace.id === action.payload.workspaceId
            ? {
                ...workspace,
                license: action.payload.license,
              }
            : workspace
      );
    },
    setWorkspaceNotes: (state, action) => {
      state.workspacesInfo.workspaces = state.workspacesInfo.workspaces.map(
        (workspace) =>
          workspace.id === action.payload.workspaceId
            ? {
                ...workspace,
                notes: action.payload.notes,
              }
            : workspace
      );
    },
  },
});

export const {
  setAdminType,
  setWorkspacesInfo,
  setTabActive,
  setWorkspacesSearchTerm,
  setSortBy,
  filterUsers,
  setRedirectedWorkspace,
  setUserSearchTerm,
  setUsersInfo,
  setLicenseInfo,
  setAuthentication,
  setWorkspaceBannerProperties,
  setPasswordExpiryPeriod,
  setWorkspaceLicense,
  setWorkspaceNotes,
} = systemAdminSlice.actions;

export default systemAdminSlice.reducer;
